import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';
import { useEffect, useRef } from 'react';

export const JSBarCodeGenerator = ({ text, format }) => {
  useEffect(() => {
    JsBarcode('#barcode', text, {
      format,
      margin: 0,
      displayValue: false,
    });
  }, [text]);

  return <svg className='pt-card-barcode' id='barcode' alt='barcode' preserveAspectRatio='none'></svg>;
};

export const QRCodeGenerator = ({ text, style }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (canvasRef.current) {
      QRCode.toCanvas(canvasRef.current, text, style, (error) => {
        if (error) console.error(error);
      });
    }
  }, [text]);

  return <canvas ref={canvasRef} />;
};
